import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import queryString from 'query-string'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

const thirtyPartyMap = {
  400031: 'LINE',
  400032: 'Facebook',
  400033: 'Google',
}

export function DialogRepeatBindAccount() {
  const { t } = useTranslation()
  const [content, setContent] = useState('')
  const [open, setOpen] = useState(false)

  const search = useMemo(() => queryString.parse(window.location.search), [])

  useEffect(() => {
    const searchError = search?.error
    console.log(typeof searchError)
    if (!searchError || typeof searchError !== 'string') return
    if (Object.keys(thirtyPartyMap).includes(searchError)) {
      setOpen(true)
      setContent(thirtyPartyMap[searchError as unknown as keyof typeof thirtyPartyMap])
    }
    /** 只清除 error 參數，保留其他 query (如 lineBinding) */
    const { error, ...restSearch } = search
    const newSearch = queryString.stringify(restSearch)
    const newUrl = newSearch ? `${window.location.pathname}?${newSearch}` : window.location.pathname
    window.history.replaceState(null, '', newUrl)
  }, [search])

  return (
    <Dialog
      disablePortal
      onClose={() => setOpen(false)}
      open={open}
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '320px',
          },
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Text color={colors.grey900} align="center" variant="h4">{t('login.cannotBindRepeatedly')}</Text>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: '8px 16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Text align="center" variant="body">{t('login.isAlreadyBound', { type: content })}</Text>
      </DialogContent>
      <DialogActions>
        <Button fullWidth onClick={() => setOpen(false)}>
          {t('button.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
